<template>
  <!-- Main Content -->
  <v-card class="mx-auto" height="100%" width="100%">
    <!-- Contents -->
    <v-container class="pa-0" fluid>
      <!-- Review Charts -->
      <!-- Daily review requests -->
      <v-row class="ma-0 d-flex justify-space-around">
        <v-card class="mt-8 pa-4 card-review-chart" color="grey lighten-4">
          <v-card-title>
            <v-row align="start">
              <div>
                <span
                  class="display-2 font-weight-black"
                  v-text="this.daysSinceLastRequest"
                ></span>
                <strong class="title">
                  {{ this.daysSinceLastRequest == 1 ? "day" : "days" }}</strong
                >
              </div>
            </v-row>
          </v-card-title>
          <v-card-subtitle class="pt-0">
            <v-row align="start">Last review request</v-row>
          </v-card-subtitle>
          <v-sheet color="transparent">
            <v-sparkline
              :smooth="sparkLineOptions.smooth"
              :line-width="sparkLineOptions.lineWidth"
              :value="dailyReviewRequestsChartData"
              :color="sparkLineOptions.color"
              auto-draw
              :stroke-linecap="sparkLineOptions.strokeLineCap"
            ></v-sparkline>
          </v-sheet>
        </v-card>
        <!-- Monthly review requests -->
        <v-card class="mt-8 pa-4 card-review-chart" color="grey lighten-4">
          <v-card-title>
            <v-row align="start">
              <div>
                <span
                  class="display-2 font-weight-black"
                  v-text="this.last30ReviewRequests"
                ></span>
                <strong class="title"></strong>
              </div>
            </v-row>
          </v-card-title>
          <v-card-subtitle class="pt-0">
            <v-row align="start">{{
              this.last30ReviewRequests == 1
                ? "Monthly review request"
                : "Monthly review requests"
            }}</v-row>
          </v-card-subtitle>
          <v-sheet color="transparent">
            <v-sparkline
              :smooth="sparkLineOptions.smooth"
              :line-width="sparkLineOptions.lineWidth"
              :value="monthlyReviewRequestsChartData"
              :color="sparkLineOptions.color"
              auto-draw
              :stroke-linecap="sparkLineOptions.strokeLineCap"
            ></v-sparkline>
          </v-sheet>
        </v-card>

        <!-- Active Review Types -->
        <v-card
          v-for="reviewChart in reviewCharts"
          :key="reviewChart.id"
          class="mt-8 pa-4 card-review-chart"
          color="grey lighten-4"
        >
          <v-card-title>
            <v-row align="start">
              <div>
                <span
                  class="display-2 font-weight-black"
                  v-text="
                    reviewChart.type == 'rating'
                      ? getLastReviewTypeAvg(reviewChart.source)
                      : getLastReviewTypeCount(reviewChart.source)
                  "
                ></span>
                <strong class="title">{{
                  reviewChart.type == "rating" ? "/ 5.0" : ""
                }}</strong>
              </div>
            </v-row>
          </v-card-title>
          <v-card-subtitle class="pt-0">
            <v-row align="start">{{ reviewChart.sourceTitle }}</v-row>
          </v-card-subtitle>
          <v-sheet color="transparent">
            <v-sparkline
              :smooth="sparkLineOptions.smooth"
              :line-width="sparkLineOptions.lineWidth"
              :value="reviewChart.chartData"
              :color="sparkLineOptions.color"
              auto-draw
              :stroke-linecap="sparkLineOptions.strokeLineCap"
            ></v-sparkline>
          </v-sheet>
        </v-card>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
export default {
  name: "ReviewsIndicators",
  components: {},
  data() {
    return {
      sparkLineOptions: {
        color: "#2962FF",
        smooth: 10,
        lineWidth: 2,
        strokeLineCap: "round"
      },
      chartoptions: null,
      chartFieldOptions: {
        data: this.reviewRequestHistoryFilledZeroMonth
          ? this.reviewRequestHistoryFilledZeroMonth.map(val => {
              return {
                y: val["dailyReviewRequests"],
                t: new Date(val["createdAt"])
              };
            })
          : [{ y: 0, t: new Date() }],
        labels: this.reviewRequestHistoryFilledZeroMonth
          ? this.reviewRequestHistoryFilledZeroMonth.map(val => {
              return new Date(val["createdAt"] + 86400000);
            })
          : [new Date()],
        yAxisLabel: "Daily Review Requests",
        suggestedMax: 4,
        suggestedMin: 0,
        minUnit: "week"
      }
    };
  },
  async mounted() {},
  created() {
    this.$store.dispatch("entities/bizReviewTypes/hydrate");
    this.$store.dispatch("entities/bizReviewSettings/hydrate", 0);
    this.$store.dispatch("entities/bizReviewHistories/hydrate", 0);
    this.$store.dispatch("entities/bizMetrics/getReviewRequests");
    this.$store.dispatch("entities/bizMetrics/getDailyReviewRequests");
  },
  computed: {
    reviewCharts() {
      let reviewCharts = [];
      if (!this.reviewSettings) {
        return reviewCharts;
      }
      const activeReviewTypes = this.reviewSettings.activeReviewTypes;
      for (
        let rt = 0;
        activeReviewTypes && rt < activeReviewTypes.length;
        rt++
      ) {
        const reviewTypeCode = activeReviewTypes[rt];

        const reviewType =
          this.reviewTypes.find(val => {
            return val.code == reviewTypeCode;
          }) || {};
        const ratingsType = {
          id: `${reviewTypeCode}-rating`,
          source: reviewTypeCode,
          type: "rating",
          sourceTitle: reviewType.name + " avg rating",
          chartData: this.getReviewTypeAvg(reviewTypeCode)
        };
        const ratingsAvg = {
          id: `${reviewTypeCode}-count`,
          source: reviewTypeCode,
          type: "count",
          sourceTitle: reviewType.name +
            (this.getLastReviewTypeCount(reviewTypeCode) == 1
              ? " rating"
              : " ratings"),
          chartData: this.getReviewTypeCount(reviewTypeCode)
        };
        reviewCharts.push(ratingsType);
        reviewCharts.push(ratingsAvg);
      }
      return reviewCharts;
    },
    dailyReviewRequestsChartData() {
      return this.reviewRequestHistoryFilledZeroMonth.map(val => {
        return parseInt(val.dailyReviewRequests);
      });
    },
    monthlyReviewRequestsChartData() {
      let data = this.reviewRequestHistoryFilledZeroYear.map(val => {
        return parseInt(val.monthlyReviewRequests);
      });
      return data;
    },
    reviewTypes() {
      const reviewTypes = this.$store.getters["entities/bizReviewTypes/query"]()
        .orderBy("name", "desc")
        .get();
      return reviewTypes;
    },
    reviewSettings() {
      const revSettings = this.$store.getters[
        "entities/bizReviewSettings/query"
      ]().get();
      if (revSettings && revSettings.length > 0) {
        return revSettings[0];
      } else {
        return {};
      }
    },
    reviewHistory() {
      const revHist = this.$store.getters["entities/bizReviewHistories/query"]()
        .orderBy("createdAt", "asc")
        .get();
      return revHist;
    },
    daysSinceLastRequest() {
      const origDate = new Date(this.lastReviewRequestDate);
      const oneDay = 1000 * 60 * 60 * 24;
      let date1InMs = origDate.getTime();
      let date2InMs = new Date().getTime();
      let differenceInMs = date2InMs - date1InMs;
      return date1InMs == 0 ? "N/A" : Math.round(differenceInMs / oneDay);
    },
    reviewRequestHistory() {
      const metric = this.$store.getters["entities/bizMetrics/find"](
        "daily-review-requests"
      );
      if (metric && metric.metricValue && metric.metricValue.length > 0) {
        return metric.metricValue.map(val => {
          return {
            createdAt: Date.parse(new Date(val.date)),
            dailyReviewRequests: val.reviewRequests
          };
        });
      } else {
        return [];
      }
    },
    reviewRequestHistoryFilledZeroMonth() {
      let reviewRequestHistoryMap = {};
      this.reviewRequestHistory.forEach(val => {
        const formattedDate = new Date(
          new Date(new Date(val.createdAt)).setUTCHours(0, 0, 0, 0)
        );
        reviewRequestHistoryMap[Date.parse(formattedDate)] =
          val.dailyReviewRequests;
      });
      let dateRangeArray = this.getLastNDaysArray(30);
      let filledMonth = [];
      dateRangeArray.forEach(val => {
        const dateParseVal = Date.parse(val);
        filledMonth.push({
          createdAt: new Date(dateParseVal),
          dailyReviewRequests: reviewRequestHistoryMap[dateParseVal]
            ? reviewRequestHistoryMap[dateParseVal]
            : 0
        });
      });
      return filledMonth.reverse();
    },
    reviewRequestHistoryFilledZeroYear() {
      let vueThis = this;
      let reviewRequestHistoryMap = {};
      this.reviewRequestHistory.forEach(val => {
        reviewRequestHistoryMap[
          vueThis.setDateFirstOfMonthFormat(val.createdAt)
        ] = reviewRequestHistoryMap[
          vueThis.setDateFirstOfMonthFormat(val.createdAt)
        ]
          ? reviewRequestHistoryMap[
              vueThis.setDateFirstOfMonthFormat(val.createdAt)
            ] + val.dailyReviewRequests
          : val.dailyReviewRequests;
      });
      let dateRangeArray = this.getLastNMonthArray(12);
      let filledPeriod = [];
      dateRangeArray.forEach(val => {
        filledPeriod.push({
          createdAt: new Date(vueThis.setDateFirstOfMonthFormat(val)),
          monthlyReviewRequests: reviewRequestHistoryMap[
            vueThis.setDateFirstOfMonthFormat(val)
          ]
            ? reviewRequestHistoryMap[vueThis.setDateFirstOfMonthFormat(val)]
            : 0
        });
      });
      return filledPeriod.reverse();
    },
    last30ReviewRequests() {
      const metric = this.$store.getters["entities/bizMetrics/find"](
        "last30ReviewRequests"
      );
      return metric && metric.metricValue ? metric.metricValue : 0;
    },
    lastReviewRequestDate() {
      const metric = this.$store.getters["entities/bizMetrics/find"](
        "lastReviewRequestDate"
      );
      return metric && metric.metricValue ? metric.metricValue : 0;
    },
    monthDayFormat() {
      return "MM/DD/YYYY";
    },
    monthFormat() {
      return "MM/YYYY";
    },
    reviewFeedbacks() {
      const feedbacks = this.$store.getters[
        "entities/bizReviewFeedbacks/query"
      ]()
        .orderBy("createdAt", "desc")
        .get();
      return feedbacks.map(val => {
        const tempCust = this.$store.getters["entities/customers/find"](
          val.customerId
        );
        return {
          id: val.id,
          date: val.createdAt
            ? new Date(val.createdAt).toLocaleDateString("en-US")
            : "",
          message: val.message,
          customerName:
            tempCust && tempCust.longName ? tempCust.longName : "Anonymous"
        };
      });
    }
  },
  watch: {},
  methods: {
    getReviewTypeCount(typeCode) {
      const type = this.reviewTypes.filter(val => {
        return val.code == typeCode;
      });
      if (!(type && type.length > 0)) {
        return [0, 0];
      } else {
        const history = this.reviewHistory.filter(val => {
          return val.bizReviewTypeId == type[0].id;
        });
        if (history && history.length > 0) {
          const historyVal = history.map(val => {
            return val.reviewCount;
          });
          return historyVal.length > 1
            ? historyVal
            : [...historyVal, ...historyVal];
        } else {
          return [0, 0];
        }
      }
    },
    getLastReviewTypeCount(typeCode) {
      const type = this.reviewTypes.filter(val => {
        return val.code == typeCode;
      });
      if (!(type && type.length > 0)) {
        return "N/A";
      } else {
        const history = this.reviewHistory.filter(val => {
          return val.bizReviewTypeId == type[0].id;
        });
        if (history && history.length > 0) {
          const historyVal = history.map(val => {
            return val.reviewCount;
          });
          return historyVal[0];
        } else {
          return "N/A";
        }
      }
    },
    getReviewTypeAvg(typeCode) {
      const type = this.reviewTypes.filter(val => {
        return val.code == typeCode;
      });
      if (!(type && type.length > 0)) {
        return [0, 0];
      } else {
        const history = this.reviewHistory.filter(val => {
          return val.bizReviewTypeId == type[0].id;
        });
        if (history && history.length > 0) {
          const historyVal = history.map(val => {
            return val.reviewAvg;
          });
          return historyVal.length > 1
            ? historyVal
            : [...historyVal, ...historyVal];
        } else {
          return [0, 0];
        }
      }
    },
    getLastReviewTypeAvg(typeCode) {
      const type = this.reviewTypes.filter(val => {
        return val.code == typeCode;
      });
      if (!(type && type.length > 0)) {
        return "N/A";
      } else {
        const history = this.reviewHistory.filter(val => {
          return val.bizReviewTypeId == type[0].id;
        });
        if (history && history.length > 0) {
          const historyVal = history.map(val => {
            return val.reviewAvg;
          });
          return historyVal[0];
        } else {
          return "N/A";
        }
      }
    },
    getLastNDaysArray(nDays) {
      const end = new Date(new Date().setUTCHours(0, 0, 0, 0));
      const start = new Date(
        new Date(new Date().setUTCHours(0, 0, 0, 0)).setDate(
          end.getDate() - nDays
        )
      );
      let arr = new Array();
      let dt = new Date(start);
      while (dt <= end) {
        arr.push(new Date(dt));
        dt.setDate(dt.getDate() + 1);
      }
      return arr;
    },
    getLastNMonthArray(nMonths) {
      const now = new Date();
      const thisMonth = new Date(
        this.setTwoDigitNum(now.getMonth() + 1) + "/1/" + now.getFullYear()
      );
      const arr = [0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1].map(val => {
        return new Date(
          new Date(
            new Date(thisMonth.setMonth(thisMonth.getMonth() - val)).setDate(1)
          ).setUTCHours(0, 0, 0, 0)
        );
      });
      return arr;
    },
    setDateFirstOfMonthFormat(date) {
      if (typeof date == "string") {
        date = (date + ".000Z").replace(" ", "T");
      }
      const d = new Date(new Date(date));
      const d2 =
        d.getUTCFullYear() +
        "-" +
        this.setTwoDigitNum(d.getUTCMonth() + 1) +
        "-01T00:00:00.000Z";
      return Date.parse(d2);
    },
    setTwoDigitNum(n) {
      return n < 10 ? "0" + n : "" + n;
    }
  }
};
</script>

<style scoped lang="stylus">
.card-review-chart {
  width: 100%;
  max-width: 350px;
  margin: 1rem 1rem 1rem;
}
.fluid-container .row {
  max-width: 1000px;
  margin: 2rem auto 0;
}
.fluid-container .review-feedback {
  margin: 4rem auto;
}
.stat-card {
  margin-left: auto;
  margin-right: auto;
  height: 10rem;
  width: 11rem;
}
.stat-card h2 {
  margin: 2.5rem auto .25rem;
}
.stat-card div {
  margin: 0 auto 1rem;
  text-align: center;
}
.card {
  margin-bottom: 1.5rem;
  border-color: #edf2f9;
  box-shadow: 0 0.75rem 1.5rem rgba(18,38,63,.03);
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border: 1px solid #edf2f9;
  border-radius: .5rem;
}
.hoverable:hover {
  cursor: pointer;
  background-color: #eee;
}
.line-chart {
  width: 100% !important;
  max-height: 300px !important;
}
.stat-sub-text {
  font-size: .7rem;
}


blockquote{
  font-size: 1rem;
  background: #f9f9f9;
  border-left: 10px solid #ccc;
  margin: .5em 10px;
  padding: 0 10px;
  quotes: "\201C""\201D""\201C""\201D";
  padding: 10px 20px;
  line-height: 1.4;
}

blockquote:before {
  content: open-quote;
  display: inline;
  height: 0;
  line-height: 0;
  left: -.25rem;
  position: relative;
  top: 1.5rem;
  color: #ccc;
  font-size: 3rem;
  font-family: serif
}

blockquote p {
  margin: 0;
}

footer{
  margin:0;
  text-align: right;
  font-size: 1rem;
  font-style: italic;
}
.feedback-date {
  font-size: .75rem;
}
</style>
